import FiberNewIcon from '@mui/icons-material/FiberNew';
import React from 'react';

import { ServiceTitanPortalV2Company } from '_lib/api/apiTypes.shim';
import { Typography } from '_lib/components/Typography/Typography';
import { ServiceTitanAvailability } from '_lib/constants/company.constants';

export const AvailabilityScheduleMessage = <T extends Pick<ServiceTitanPortalV2Company, 'dataProvider'>>(props: {
  company: T;
}) => {
  const { company } = props;
  return (
    <Typography component='span'>
      {company.dataProvider.providerOptions.useAdaptiveCapacity ? (
        <>
          {ServiceTitanAvailability.USE_ADAPTIVE_AVAILABILITY}
          <FiberNewIcon color='primary' sx={{ verticalAlign: 'middle', paddingLeft: 0.25 }} />
        </>
      ) : (
        ServiceTitanAvailability.USE_GET_AVAILABILITY
      )}
    </Typography>
  );
};
